import { useState } from 'react';

export const LazyImage = ({ src, alt = '', styles, ...props }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div style={{ position: 'relative' }}>
			{!loaded && (
				<div
					style={{
						position: 'absolute',
						width: '100%',
						height: '100%',
						backgroundColor: '#A5A5A5',
						borderRadius: '18px',
					}}
				/>
			)}
			<img
				src={src}
				alt={alt}
				onLoad={() => setLoaded(true)}
				style={{
					width: '100%',
					height: 'auto',
					opacity: loaded ? 1 : 0,
					transition: 'opacity 0.3s ease-in',
				}}
				loading="lazy"
				{...props}
			/>
		</div>
	);
};
